
interface ILevel {txt:string; val:number; key: string};
const LevelEnum : {[key: string]: ILevel} = {
  debug: {txt: "DEBUG", val: 0, key: "debug"},
  info: {txt: "INFO ", val: 1, key: "info"},
  warning: {txt: "WARNG", val: 2, key: "warning"},
  error: {txt: "ERROR", val: 3, key: "error"},
  critical: {txt: "CRITC", val: 4, key: "critical"},
}

export function isLevelGreaterOrEqual(base: ILevel, level: ILevel): boolean {
  return base.val<=level.val;
}

function logAny(o:any): string {
  switch (typeof o) {
    case "undefined":
      return "UNDEF";
    case "object":
      return JSON.stringify(o);
    default:
      return o.toString();
  }
}

export class Logger {
  static get(name: string): Logger {
    return new Logger(name);
  }
  private static _globalLevel: ILevel|undefined = undefined;
  public static get level(): ILevel {
     return Logger._globalLevel || LevelEnum[process.env.LOGGER_LEVEL||"debug"];
  }
  public static setlevel(level:string) {
    Logger._globalLevel = LevelEnum[level] || LevelEnum.debug;
  }
  private _level: ILevel|undefined;
  private constructor(private name: string) {
    if (!this.name) this.name="";
    this._level = undefined;
  }
  public set level(l: string) {this._level = LevelEnum[l]||Logger.level}
  public get level(): string { return this._level?.key||Logger.level.key }
  private get iLevel(): ILevel { return this._level||Logger.level }


  private log(level: ILevel, ...messages: any[]) {
    if (isLevelGreaterOrEqual(this.iLevel, level)) {
      console.log(
        `${this.name.padEnd(8, ' ')}:${new Date().toISOString()}:${level.txt}:${messages
          .map((a) => logAny(a))
          .join(",")}`
      );
    }
  }
  debug(...messages: any[]): void {
    this.log(LevelEnum.debug, ...messages);
  }
  info(...messages: any[]): void {
    this.log(LevelEnum.info, ...messages);
  }
  warn(...messages: any[]): void {
    this.log(LevelEnum.warning, ...messages);
  }
  error(message: string, err?: Error): void {
    this.log(LevelEnum.error, message, err?err.message:'');
    if (err instanceof Error && err.stack) this.log(LevelEnum.error, err.stack.substring(0, 600));
  }
  critical(message: string, err?: Error): void { 
    this.error(message, err);
    process.exit(1)
  }

  measure<T>(message: string, fn: ()=>T|Promise<T>): T|Promise<T> {
    const start = Date.now();
    const trace = (err:boolean) => {
      this.log(LevelEnum.debug, `${message} took ${Date.now() - start} ms`+(err? " with error":""));
    }
    try {
      let result = fn();
      if (result instanceof Promise) {
        const prom = result;
        result = new Promise((resolve, reject) => {
          prom.then((r) => {
            trace(false);
            resolve(r);
          }).catch((e) => {
            trace(true);
            reject(e);
          });
        });
      } else {
        trace(false);
      }
      return result;
    } catch(e) {
      trace(true);
      throw e;
    }
  }

}